import { StoreState } from '@/redux/types';
import { getCore } from './getCore';

export function getUserId(state: StoreState) {
  return getCore(state).user?.userId;
}
